const module = { name: 'global/jcarousel.deferImages', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    DEFAULT_IMG: '.carousel-image',
}


const Events = {
    ANIMATE: 'jcarousel:animate',
}


let hasRun = false
function jcarouselDeferImages(options) {
    options = $.extend({
        imgSelector: Selectors.DEFAULT_IMG
    }, options);
    function loadImg($slide) {
        if ($slide.data('loaded')) {
            return;
        }
        $slide.data('loaded', true);
        const $img = $slide.find(options.imgSelector);
        if ($img.length) {
            $img.prop('src', $img.data('src'));
        }
    }
    return this.each(function () {
        const $this = $(this);
        function preload() {
            const $currentSlide = $this.jcarousel('visible');
            [$currentSlide, $currentSlide.next(), $currentSlide.prev()].forEach(loadImg);
        }
        $this.on(Events.ANIMATE, preload);
        preload();
    });
}
function init() {
    if (hasRun) {
        return;
    }
    hasRun = true;
    $.fn.jcarouselDeferImages = jcarouselDeferImages;
}
module.exports = {
    init,
};
export default module.exports;